import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function MachinaryRow({ data, onEdit }) {
  const columns = [
    {
      title: "Machinary Name",
      dataIndex: "machinary_name",
      key: "machinary_name",
      align: "center",
    },
    {
      title: "Machinary Make",
      dataIndex: "machinary_make",
      key: "machinary_make",
      align: "center",
    },
    {
      title: "Machinary Model",
      dataIndex: "machinary_model",
      key: "machinary_model",
      align: "center",
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
